import Radio from '@/components/Radio';
import MaterialIcon from '@/components/icon/MaterialIcon';
import styled from 'styled-components';

interface Props {
  isImmediatePayOrder?: boolean;
  orderDenyReasons: string[];
  cancelReason: string;
  setCancelReason: (reason: string) => void;
  onSubmitOrderCancelByPharmacy: () => void;
  onClickReset: () => void;
}

const PrescriptionCancelReason = ({
  isImmediatePayOrder,
  orderDenyReasons,
  cancelReason,
  setCancelReason,
  onSubmitOrderCancelByPharmacy,
  onClickReset
}: Props) => {
  return (
    <div>
      <StatusTitle>조제 거절 사유를 선택해주세요.</StatusTitle>
      {isImmediatePayOrder && (
        <StatusDescription>
          이미 결제된 건으로, 조제 거절 시 <span>환불이 진행됩니다.</span>
        </StatusDescription>
      )}
      <CancelCheckBoxWrapper>
        {orderDenyReasons.map((reason, key) => (
          <Radio
            key={key}
            isSelected={cancelReason === reason}
            onClick={() => setCancelReason(reason)}
            content={reason}
          />
        ))}
      </CancelCheckBoxWrapper>
      <Button
        primary
        onClick={() => onSubmitOrderCancelByPharmacy()}
        disabled={!cancelReason}>
        조제 거절
      </Button>
      <ResetOrderReadyTypeButton onClick={onClickReset}>
        <MaterialIcon name={'replay'} size={16} />
        조제접수 초기화
      </ResetOrderReadyTypeButton>
    </div>
  );
};

export default PrescriptionCancelReason;

const Button = styled.button<{ primary?: boolean }>`
  padding: 16px;
  border-radius: 12px;
  cursor: pointer;
  width: 100%;
  border: 1px solid;

  ${({ theme, primary }) => `
    ${theme.DF_TYPOGRAPHY.UI16SB};
    color: ${primary ? theme.DF_COLOR.WHITE : theme.DF_COLOR.GRAY600};
    background: ${primary ? theme.DF_COLOR.PRIMARY500 : theme.DF_COLOR.WHITE};
    border-color: ${
      primary ? theme.DF_COLOR.PRIMARY500 : theme.DF_COLOR.GRAY200
    }};
    
    &:hover:not(:disabled) {
      opacity: 0.7;
    }
  
    :disabled {
      background: ${theme.DF_COLOR.GRAY100};
      border-color: ${theme.DF_COLOR.GRAY100};
      cursor: default;
    }
  `};
`;

const StatusTitle = styled.div`
  ${({ theme }) => `
    ${theme.DF_TYPOGRAPHY.UI24B};
  `};
`;

const StatusDescription = styled.div`
  margin-top: 5px;

  ${({ theme }) => `
    ${theme.DF_TYPOGRAPHY.UI15R};
    color: ${theme.DF_COLOR.GRAY500};
    span {
      color: ${theme.DF_COLOR.PRIMARY800};
    }
  `};
`;

const CancelCheckBoxWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  margin: 24px 0;

  & > div {
    width: calc(50% - 15px);
    display: flex;
    ${({ theme }) => `
      ${theme.DF_TYPOGRAPHY.UI16M};
    `};
  }
`;

const ResetOrderReadyTypeButton = styled.button`
  width: 100%;
  padding: 4px;
  margin-top: 16px;
  display: flex;
  justify-content: center;
  align-items: center;

  div {
    margin-right: 8px;
  }
  &:hover {
    cursor: pointer;
  }

  ${({ theme }) => `
    ${theme.DF_TYPOGRAPHY.UI14M};
    color: ${theme.DF_COLOR.GRAY600};
  `};
`;
